export default __webpack_public_path__ + "static/media/law-code-tablet-of-king-hammurabi-from-nippur.40e393a3.jpg";